
































































import { defineComponent } from '@nuxtjs/composition-api';
import type { CodeContentMenuItems } from '@/components/storyblok/CodeContentMenuItems.vue';

export type CodeContent = Blok & {
  title: string;
  titleWithColor: string;
  titleColor: string;
  description: string;
  image: BlokFieldAsset;
  credits: string;
  creditsColor: string;
  menuItems: string[];
  content: CodeContentMenuItems[];
};

export default defineComponent({
  props: {
    blok: {
      type: Object as () => CodeContent,
      required: true,
    },
  },
  data() {
    return {
      selected: this.blok.menuItems[0]
        ? this.blok.menuItems[0].toLowerCase()
        : '',
    };
  },
  computed: {
    menuItems(): string[] {
      return this.blok.menuItems;
    },
    selectedContent(): Blok {
      const isSelectedElement = (element: any) =>
        element.title.toLowerCase() === this.selected;
      const index = this.blok.content.findIndex(isSelectedElement);
      return this.blok.content[index];
    },
  },
});
